import { useState } from "react";
import { Link } from "react-router-dom";
import { mockPosts } from "@/mocks/community";

export default function CommunityHighlights() {
  const [activeIdx, setActiveIdx] = useState(0);
  const featured = mockPosts.slice(0, 3);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-teal-600 text-sm font-semibold tracking-widest uppercase">Community</span>
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            ( Voices From Our
            <br />
            <span className="text-teal-600">Coaching Community</span> )
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Real insights, real transformations — shared by coaches and learners just like you.
          </p>
        </div>

        {/* Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {featured.map((post, i) => (
            <div
              key={post.id}
              className={`rounded-2xl overflow-hidden border transition-all cursor-pointer ${
                activeIdx === i ? "border-teal-400 ring-2 ring-teal-100" : "border-gray-100 hover:border-teal-200"
              }`}
              onClick={() => setActiveIdx(i)}
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 bg-white">
                <div className="flex flex-wrap gap-2 mb-3">
                  {post.tags.map((tag) => (
                    <span key={tag} className="text-xs bg-teal-50 text-teal-600 px-2 py-1 rounded-full font-medium">
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="font-semibold text-gray-900 text-sm mb-3 leading-snug">{post.title}</h3>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <img
                      src={post.avatar}
                      alt={post.author}
                      className="w-7 h-7 rounded-full object-cover object-top"
                    />
                    <div>
                      <p className="text-xs font-semibold text-gray-800">{post.author}</p>
                      <p className="text-xs text-gray-400">{post.niche}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 text-xs" />
                    <span className="text-xs font-semibold text-gray-700">{post.rating}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Selected Post Detail */}
        <div className="bg-[#F7F6F3] rounded-2xl p-8 flex flex-col md:flex-row gap-8 items-start">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="bg-teal-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                ★ {featured[activeIdx].rating} · {featured[activeIdx].ratingCount} ratings
              </span>
            </div>
            <blockquote
              className="text-gray-800 text-lg leading-relaxed mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              "{featured[activeIdx].content}"
            </blockquote>
            <div className="flex items-center gap-3">
              <img
                src={featured[activeIdx].avatar}
                alt={featured[activeIdx].author}
                className="w-12 h-12 rounded-full object-cover object-top"
              />
              <div>
                <p className="font-semibold text-gray-900 text-sm">{featured[activeIdx].author}</p>
                <p className="text-gray-400 text-xs">{featured[activeIdx].niche}</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-end gap-4">
            <div className="flex items-center gap-3">
              <span className="text-gray-400 text-sm">{featured[activeIdx].comments} comments</span>
              <span className="text-gray-400 text-sm">{featured[activeIdx].likes} likes</span>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setActiveIdx((prev) => (prev - 1 + featured.length) % featured.length)}
                className="w-10 h-10 flex items-center justify-center border border-gray-300 rounded-lg hover:border-teal-400 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-gray-600" />
              </button>
              <button
                onClick={() => setActiveIdx((prev) => (prev + 1) % featured.length)}
                className="w-10 h-10 flex items-center justify-center bg-gray-900 rounded-lg hover:bg-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-white" />
              </button>
            </div>
            <Link
              to="/community"
              className="text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              View All Posts →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
